<template>
    <div class="sustainable-component wage-money-individual-salary">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-money-individual-salary</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6 mb-5">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="doUpdate">
                        Uppdatera löneunderlag
                    </v-btn>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printIndividualSalary">Visa översikt över de individuella tilläggens värde</a>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <v-expansion-panels variant="accordion" class="theme-orange">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="orange">
                                Skapa värden på tillägg som omfattar alla
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <v-radio-group v-bind:disabled="disabled" v-model="calculationType">
                                                <v-radio @click="changeType($event,'0')" label="Alt 1. Pengar läggs in direkt i systemet på respektive faktor och grad." value="0"></v-radio>
                                                <v-radio @click="changeType($event,'1')" label="Alt 2. Tilläggens värde baseras på poängintervall." value="1"></v-radio>
                                                <v-radio @click="changeType($event,'2')" label="Alt 3. Tilläggens värde baseras på kronor per poäng." value="2"></v-radio>
                                            </v-radio-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            Översikt:
                                            <div class="container-fluid p-0">
                                                <div class="row">
                                                    <div class="col-12">
                                                        För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                                        "Skapa värden i lönesystemet" som finns under tabellen.

                                                        <table class="table table-light table-hover table-striped">
                                                            <thead class="thead-light">
                                                                <tr>
                                                                    <th class="col-4">Poäng fr.o.m.</th>
                                                                    <th class="col-3">Poäng t.o.m.</th>
                                                                    <th class="col-3" v-if="calculationType == '0'">Värde kr</th>
                                                                    <th class="col-3" v-if="calculationType == '1' || calculationType == '2'">Poäng</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(factorGrade, index) in individualFactorGrades" :key="index">
                                                                    <td>{{factorGrade.FactorName}}</td>
                                                                    <td>{{factorGrade.GradeNumber}}</td>
                                                                    <td v-if="calculationType == '0'">
                                                                        <span v-decimal-text.max2="factorGrade.Salary"></span>
                                                                    </td>
                                                                    <td v-if="calculationType == '1' || calculationType == '2'">
                                                                        {{factorGrade.Points}}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="calculationType == '0'">
                                        <div class="col-12 col-md-6 mr-3">
                                            <div class="card px-3 py-5 rounded common-label-container">
                                                <div class="common-label-tab-container rounded">
                                                    <div class="px-3 pt-1 rounded tab-contained" style="">Konstruktion</div>
                                                </div>
                                                <div>
                                                    <!-- content -->
                                                    <div class="container-fluid p-0">
                                                        <div class="row">
                                                            <div class="col-12">

                                                                <table class="table table-light table-hover table-striped">
                                                                    <thead class="thead-light">
                                                                        <tr>
                                                                            <th class="col-4">Faktor</th>
                                                                            <th class="col-3">Grad</th>
                                                                            <th class="col-3">Värde</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(factorGrade, index) in individualFactorGrades" :key="index">
                                                                            <td>{{factorGrade.FactorName}}</td>
                                                                            <td>{{factorGrade.GradeNumber}}</td>
                                                                            <td>
                                                                                <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" v-model="factorGrade.Salary" hide-details="true" density="compact" variant="outlined"></v-text-field>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>

                                                                </table>

                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="saveEmployeeIndividualFactorGrades">
                                                                    Skapa värden i lönesystemet
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- end content -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="calculationType == '1'">
                                        <div class="col-12 col-md-6 mt-3 pt-3">
                                            <div class="card px-3 py-5 rounded common-label-container">
                                                <div class="common-label-tab-container rounded">
                                                    <div class="px-3 pt-1 rounded common-label-tab-contained" style="">Konstruktion</div>
                                                </div>
                                                <div>
                                                    <!-- content -->
                                                    <div class="container-fluid p-0">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                För att spara data klickar du antingen på ”Spara” som finns på respektive rad eller knappen
                                                                "Skapa värden i lönesystemet" som finns under tabellen.

                                                                <table class="table table-light table-hover table-striped">
                                                                    <thead class="thead-light">
                                                                        <tr>
                                                                            <th class="col-6">Poäng fr.o.m.</th>
                                                                            <th class="col-2">Poäng t.o.m.</th>
                                                                            <th class="col-3">Värde kr</th>
                                                                            <th class="col-1"></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(interval) in salaryIntervals" :key="interval.SalaryIntervalId">
                                                                            <td>{{interval?.From}}</td>
                                                                            <td>{{interval?.To}}</td>
                                                                            <td><span v-decimal-text.max2="interval?.Salary"></span></td>
                                                                            <td>
                                                                                <div class="pull-right" style="" v-if="disabled == false">
                                                                                    <div class="dropdown text-right pr-2">
                                                                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                            ...
                                                                                        </a>
                                                                                        <div class="dropdown-menu dropdown-menu-right">
                                                                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateInterval(interval)">Ändra</a>
                                                                                            <a href="javascript:void(0)" class="dropdown-item" @click="removeSalaryInterval(interval)">Ta bort</a>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-12 col-md-6 mr-3">
                                                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Poäng fr.o.m" v-model="startPoint" variant="outlined"></v-text-field>
                                                            </div>
                                                            <div class="col-12 col-md-6 mr-3">
                                                                <v-text-field v-bind:disabled="disabled" bg-color="white" label="Poäng t.o.m" v-model="endPoint" variant="outlined"></v-text-field>
                                                            </div>
                                                            <div class="col-12 col-md-6 mr-3">
                                                                <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde kr" v-model="salary" variant="outlined"></v-text-field>
                                                            </div>
                                                            <div class="col-12 col-md-6 mr-3">
                                                                <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="createInterval">
                                                                    Spara intervall
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- end content -->
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                    <div class="row mt-3" v-if="calculationType == '2'">
                                        <div class="col-12 col-md-6 mr-3">

                                            <CommonLabelContainer title="Konstruktion">
                                                <div class="container-fluid p-0">
                                                    <div class="row">
                                                        <div class="col-12">

                                                            <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde per poäng" v-model="individualSalaryPerPoint" variant="outlined"></v-text-field>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateSalariesWithPoint">
                                                                Beräkna värden
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CommonLabelContainer>
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-title color="orange">
                                Skapa värden på personliga tillägg
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            Här ska värdet kopplat till respektive person skrivas in.<br />
                                            Ofta kan värdet skrivas in först när lönesystemet är färdigkonstruerat och pengar fördelade.
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-12 col-md-8">
                                            <table class="table table-light table-hover table-striped">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th class="col-3">Anst.nr.</th>
                                                        <th class="col-3">Namn</th>
                                                        <th class="col-3">Faktor</th>
                                                        <th class="col-3">Värde kr</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(factorAddon, index) in employeeIndividualFactorAddons" :key="index">
                                                        <td>{{factorAddon.EmployeeNumber}}</td>
                                                        <td>{{factorAddon.EmployeeName}}</td>
                                                        <td>{{factorAddon.Name}}</td>
                                                        <td>
                                                            <v-text-field :decimal-sv="true" v-bind:disabled="disabled" bg-color="white" label="Värde" v-model="factorAddon.Salary" variant="outlined" hide-details="true" density="compact"></v-text-field>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-12">
                                            <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="updateEmployeeIndividualFactorPersonAddition">
                                                Skapa värden på personliga tillägg
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 col-md-6 mr-3 mt-3">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="positions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mr-3">
                    <b>Utfall</b>
                    <table class="mt-2 table table-light table-hover table-striped">
                        <thead class="thead-light">

                            <tr>
                                <th class="col-1">Anst.nr.</th>
                                <th class="col-3">Namn</th>
                                <th class="col-3">Faktor</th>
                                <th class="col-1">Grad</th>
                                <th class="col-2">Värde kr</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in jobPositionEmployeesResult" :key="index">
                                <td v-if="row.EmployeeName == 'Summa'" colspan="4"><b>Summa</b></td>
                                <td v-if="row.EmployeeName == 'Summa'"><b><span v-decimal-text.max2="row.Salary"></span></b></td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.EmployeeNumber}}</td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.EmployeeName}}</td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.IndividualFactorName}}</td>
                                <td v-if="row.EmployeeName != 'Summa'">{{row.GradeNumber}}</td>
                                <td v-if="row.EmployeeName != 'Summa'"><span v-decimal-text.max2="row.Salary"></span></td>
                            </tr>
                        </tbody>

                    </table>

                </div>
            </div>
        </div>
        <WageSalaryInterval v-bind:disabled="disabled" :model="model" ref="updateSalaryInterval" @updated="updateAfterChange"></WageSalaryInterval>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'
    import CommonLabelContainer from "../../common/common-label-container";
    import WageSalaryInterval from './update/update-salary-interval.vue'
    import { ref } from 'vue'

    const updateSalaryInterval = ref(null);
    var salaryIntervals = [];

    export default {
        emits: ['updated'],
        name: 'wage-money-individual-salary',
        components: {
            CommonLabelContainer,
            WageSalaryInterval,
            CommonSpinner,
        },
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async updateSalariesWithPoint() {
                this.loading++;
                try {
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async createInterval() {
                this.loading++;
                try {
                    await WageService.addIndividualSalaryInterval(this.startPoint, this.endPoint, this.salary);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            updateInterval(item) {
                this.loading++;
                this.updateSalaryInterval.open(item);
                this.loading--;
            },
            async removeSalaryInterval(item) {
                if (confirm(" Är du säker att du vill radera intervallet?")) {
                    this.loading++;
                    try {
                        await WageService.deleteSalaryInterval(item.SalaryIntervalId);
                        this.displaySnackBar("Borttaget");
                        this.updateAfterChange()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async updateAfterChange() {
                this.loading++;
                try {
                    await WageService.updateIndividualWagepart(false, this.calculationType, this.salary, this.individualSalaryPerPoint)
                    this.refreshIntervals();
                    this.getEmployeeIndividualFactorGrades();
                    this.getEmployeesWithIndividualFactors(this.selectedPosition)
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getPositionsWithPoints() {
                this.loading++;
                try {
                    this.positions = await WageService.getPositionsWithPoints();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadIntervals() {
                this.loading++;
                try {
                    var tmp = await WageService.getIndividualSalaryIntervals();
                    this.salaryIntervals = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async refreshIntervals() {
                this.loading++;
                try {
                    if (this.calculationType == "1") {
                        this.loadIntervals();
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async changeType(event, type) {
                event.preventDefault();
                if (confirm("Om du byter alternativ kommer befintliga blockvärden att nollställas. Vill du byta alternativ?")) {
                    this.loading++;
                    this.calculationType = type
                    try {
                        await WageService.updateIndividualWagepart(true, type, this.salary, this.individualSalaryPerPoint)
                        this.displaySnackBar("Sparat");
                        this.refreshIntervals();
                        this.getEmployeeIndividualFactorGrades();
                        this.getEmployeesWithIndividualFactors(this.selectedPosition)
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async updateEmployeeIndividualFactorPersonAddition() {
                this.loading++;
                try {
                    await WageService.updateEmployeeIndividualFactorPersonAddition(this.employeeIndividualFactorAddons);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async saveEmployeeIndividualFactorGrades() {
                this.loading++;
                try {
                    await WageService.updateEmployeeIndividualFactorGrades(this.individualFactorGrades);
                    this.displaySnackBar("Sparat");
                    this.updateAfterChange()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async getEmployeeIndividualFactorGrades() {
                this.loading++;
                try {
                    var tmp = await WageService.getEmployeeIndividualFactorGrades();
                    var latestFactorName = null;
                    for (var i = 0; i < tmp.length; i++) {
                        if (tmp[i].FactorName != latestFactorName)
                            latestFactorName = tmp[i].FactorName;
                        else
                            tmp[i].FactorName = null;
                    }
                    this.individualFactorGrades = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getSalaryPart() {
                this.loading++;
                try {
                    var salaryPart = await WageService.getWagePartIndividual();
                    this.calculationType = salaryPart.CalculationType.toString();
                    this.individualSalaryPerPoint = salaryPart.IndividualSalaryPerPoint;
                    this.getEmployeeIndividualFactorGrades();
                    this.refreshIntervals();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getEmployeesWithIndividualFactors(positionid) {
                this.loading++;
                try {
                    var tmp = await WorkOrganisationService.getEmployeesWithIndividualFactors(positionid);
                    var latestName = null;
                    for (var i = 0; i < tmp.length; i++) {
                        if (tmp[i].EmployeeName != latestName)
                            latestName = tmp[i].EmployeeName;
                        else
                            tmp[i].EmployeeName = null;
                    }
                    this.jobPositionEmployeesResult = tmp;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getEmployeeIndividualFactorPersonAddition() {
                this.loading++;
                try {
                    var result = await WageService.getEmployeeIndividualFactorPersonAddition();
                    this.employeeIndividualFactorAddons = result;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printIndividualSalary() {
                this.newWindow = window.open('/wagesettingsprint/PrintIndividualSalary', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async doUpdate(){
                this.loading++;
                try {
                    await this.updateAfterChange();
                    this.displaySnackBar("Uppdaterat");
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                startPoint: null,
                endPoint: null,
                salary: null,
                individualSalaryPerPoint: null,
                selectedPosition: null,
                salaryIntervals,
                individualFactorGrades:[],
                jobPositionEmployeesResult:[],
                calculationType:"0",
                positions: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
                employeeIndividualFactorAddons:[],
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getEmployeesWithIndividualFactors(newVal);
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.selectedPosition = this.selectedJobPosition;
            this.getPositionsWithPoints();
            this.getSalaryPart();
            this.getEmployeeIndividualFactorPersonAddition();
            
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateSalaryInterval }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .theme-orange .v-expansion-panel-title {
        background-color: #e79925 !important;
        color: white !important;
    }

    .theme-orange .v-expansion-panel-text {
        background-color: #fff7eb !important;
    }

</style>
